import React, { useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/config";
interface FooterProps {
  companyName?: string;
}

const Footer: React.FC<FooterProps> = () => {
  const [formData, setFormData] = useState({
    phone: "",
  });
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const validatePhone = (value: string) => {
    const vnPhoneRegex =
      /^(0|\+84)(3[2-9]|5[6|8|9]|7[06-9]|8[1-9]|9[0-9])[0-9]{7}$/;
    return vnPhoneRegex.test(value);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setPhone(formData.phone);
    if (!validatePhone(phone)) {
      setError("Số điện thoại không hợp lệ (VD: 0912345678)");
    } else {
      setError("");
      try {
        await addDoc(collection(db, "contacts"), {
          ...formData,
          timestamp: new Date(),
        }).then((docRef) => {
          alert(
            "Cảm ơn bạn đã gửi thông tin!, chúng tôi sẽ liên hệ sớm nhất có thể."
          );
          setFormData({ phone: "" });
        });
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  return (
    <footer className="bg-primary_gray text-gray-800 px-6 lg:px-20 py-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between">
        <div className="space-y-4 lg:w-1/3">
          <div className="flex items-center space-x-2">
            <img src="images/logo.svg" alt="Logo" className="w-10 h-10 block" />
            <span className="text-xl font-bold text-gray-800">
              <span className="text-primary_blue">Siêu Thị </span>Điện Lạnh
            </span>
          </div>
          <p className="text-sm text-gray-800">
            Dịch vụ máy lạnh chuyên nghiệp, hiệu quả, chất lượng cao với giá cả
            phải chăng.
          </p>
        </div>

        <div className="lg:w-1/2 py-10 lg:py-0 flex flex-row justify-around">
          {/* Cột Company */}
          <div>
            <h4 className="font-semibold mb-4">Công ty</h4>
            <ul className="space-y-2 text-sm text-gray-800">
              <li>
                <a href="#">Giới thiệu</a>
              </li>
              <li>
                <a href="#services">Dịch vụ</a>
              </li>
              <li>
                <a href="#staffs">Đội ngũ</a>
              </li>
            </ul>
          </div>

          {/* Cột Know More */}
          <div>
            <h4 className="font-semibold mb-4">Hỗ trợ</h4>
            <ul className="space-y-2 text-sm text-gray-800">
              <li>
                <a href="#contact">Liên hệ</a>
              </li>
              <li>
                <a href="">Privacy Policy</a>
              </li>
              <li>
                <a href="">Terms & conditions</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div className="lg:w-1/3">
          <form onSubmit={handleSubmit}>
            <h4 className="font-semibold mb-4">Cần tư vấn</h4>
            <input
              type="tel"
              placeholder="Nhập số điện thoại của bạn"
              className="w-full bg-transparent border border-gray-500 text-sm px-4 py-2 rounded-md placeholder-gray-400 text-gray-800 mb-3 focus:outline-none focus:ring-1 focus:ring-primary_blue"
              value={formData.phone}
              onChange={(e) => {
                setFormData({ ...formData, phone: e.target.value });
                setError("");
              }}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

            <button className="bg-primary_blue hover:bg-primary_blue text-white px-4 py-2 text-sm rounded-md">
              Gửi
            </button>
          </form>
        </div>
      </div>

      {/* Đường kẻ + copyright */}
      <div className="border-t border-gray-600 mt-10 pt-6 text-center text-sm text-gray-800">
        © {new Date().getFullYear()} Siêu Thị Điện Lạnh. All rights reserved. |
        Thiết kế & phát triển bởi{" "}
        <a
          href="https://www.sieuthidienlanh.vn/"
          className="text-blue-500 hover:underline"
        >
          sieuthidienlanh.vn
        </a>
      </div>
    </footer>
  );
};

export default Footer; // This is the crucial export statement
